<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="DocProductId"
      ref="list"
      unit="工单计件工资"
      :expand-all-row="false"
      :page="page"
      :show-checkbox="true"
      :show-query="true"
      :query-params="params"
      :get-data-func="api.pieceSalaryList"
      urlHash="production/piecerate/orderwage"
      :showExpand="true"
      :default-expand-all="false"
      :expand-change="expandChange"
      :temp-params="{  Status: 0 }"
      @handleNumberBlur="handleNumberBlur"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
      <template #expand-content="{ row: rows,index:i }">
        <div>
          <div style="margin: 0 0 10px 0">
            <el-button type="primary" size="mini" @click="onAdd(rows)" :disabled="!isEdit">添加</el-button>
            <!-- <el-button type="primary" size="mini" @click="onSaved(rows)">保存</el-button> -->
          </div>
          <el-table ref="table" :data="rows.ListData" border  style="width: 1100px" show-summary :summary-method="getSummaries">
            <el-table-column prop="EmpNo" label="工号" min-width="100" align="center">
              <template slot-scope="{row, $index}">
                <el-input v-model="row.EmpNo" :disabled="!isEdit || rows.PieceSalaryStatus" @click.native="openEmp($index)" />
              </template>
            </el-table-column>
            <el-table-column prop="EmpName" label="姓名" min-width="100" align="center">
              <template slot-scope="{row, $index}">
                <select-input placeholder="请选择" :disabled="!isEdit || rows.PieceSalaryStatus" :label="row.EmpName" v-model="row.EmpId" @click="openEmp($index)" />
              </template>
            </el-table-column>
            <el-table-column prop="PieceQuantity" label="计件数量" min-width="80" align="center">
              <template slot-scope="{row}">
                <el-input v-model="row.PieceQuantity" :disabled="!isEdit || rows.PieceSalaryStatus" @blur="blurNum(row,rows)" size="mini" style="width: 100%"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="PiecePrice" label="计件单价" min-width="60" align="center">
              <template slot-scope="{row}">
                <el-input v-model="row.PiecePrice" :disabled="!isEdit || rows.PieceSalaryStatus" @blur="blurPrice(row,rows)" size="mini" style="width: 100%"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="PieceAmount" @blur="blurAmount(row,rows)" label="计件金额" min-width="80" align="center">
              <template slot-scope="{row}">
                <el-input v-model="row.PieceAmount" :disabled="!isEdit || rows.PieceSalaryStatus" size="mini" style="width: 100%"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Ratio" label="系数" min-width="80" align="center">
              <template slot-scope="{row}">
                <el-input v-model="row.Ratio" :disabled="!isEdit || rows.PieceSalaryStatus" @blur="blurRatio(row)" size="mini" style="width: 100%"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="DpId" label="车间" min-width="120" align="center">
              <template slot-scope="{row}">
                <el-select v-model="row.DpId" :disabled="!isEdit || rows.PieceSalaryStatus" @change="workShopChange({},row)" placeholder="请选择部门">
                  <el-option v-for="item in dpList" :key="item.DpId" :value="item.DpId" :label="item.DpName"></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column prop="TeamId" label="班组" min-width="120" align="center">
              <template slot-scope="{row}">
              <el-select v-model="row.TeamId" :disabled="!isEdit || rows.PieceSalaryStatus">
                <el-option v-for="i in teamList" :key="i.TeamId" :value="i.TeamId" :label="i.Team" />
              </el-select>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="60px">
              <template slot-scope="{ row, $index }">
                <el-button type="text" @click="del(rows, i, row, $index)" :disabled="!isEdit || rows.PieceSalaryStatus">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- <div style="margin: 10px 0">
          </div> -->
        </div>
        
        <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp($event,rows)" />
      </template>
    </list>
    
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import empDialog from "@/components/personnel/result/record/listDialog";

export default {
  mixins: [listMixin],
  components: { list,empDialog },
  data() {
    return {
      api: require("@/api/pr/prPieceSalary").default,
      prPieceSalaryDtsApi: require("@/api/pr/prPieceSalaryDts").default,
      dpApi: require("@/api/ent/dp").default,
      teamApi: require("@/api/ba/team").default,
      params: {
        Status: 0,
      },
      rowIndex:null,
      dpList: [],
      teamList: [],
      isEdit:false
    };
  },
  mounted() {
    this.dpApi.list({Status:1}).then((res) => {
        if(res.Code==0) this.dpList = res.Data;
      });
    this.teamApi.list({}).then((res) => {
        if(res.Code==0) this.teamList = res.Data;
      });

  },
  methods: {
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    expandChange(row) {
      // let PieceSalaryId = row.PieceSalaryId  ?? 0;
      // this.prPieceSalaryDtsApi.list({PieceSalaryId}).then((res) => {
      //   if (res.Code === 0) {
      //     let data = JSON.parse(JSON.stringify(res.Data));
      //     this.$nextTick(() =>{
      //       // row.ListData = data;
      //       this.$delete(row, 'ListData')
      //       this.$set(row, 'ListData', data)
      //     })
      //   }
      // });
    },
    openEmp(index) {
      this.rowIndex = index;
      this.$refs.empDialog.open().then((that) => {
        that.getData();
      });
    },
    setIsEdit(){
      this.isEdit = !this.isEdit
    },
    onAdd(row){
      row.ListData.push({
        PieceSalaryDtsId: 0,
        EmpId: null,
        EmpNo:null,
        PieceQuantity: 0,
        PiecePrice: 0,
        PieceAmount: 0,
        DpId: null,
        TeamId: null,
        Ratio:0,
        PieceSalaryId: row.PieceSalaryId ?? 0
      });
    },
    setEmp(event, row) {
      row.ListData[this.rowIndex].EmpId = event.EmpId;
      row.ListData[this.rowIndex].EmpNo = event.EmpNo;
      row.ListData[this.rowIndex].EmpName = event.EmpName;
      row.ListData[this.rowIndex].DpId = event.DpId;
    },
    blurNum(row,rows){
      row.PieceAmount = (((row.PieceQuantity * row.PiecePrice) * 100) / 100).toFixed(2)
      row.Ratio = (((row.PieceQuantity / rows.Quantity) * 100) / 100 ).toFixed(2) 
    },
    blurPrice(row,rows){
      row.PieceAmount = (((row.PieceQuantity * row.PiecePrice)* 100) / 100).toFixed(2)
      row.Ratio = (((row.PieceQuantity / rows.Quantity) * 100) / 100 ).toFixed(2) 
    },
    blurAmount(row,rows){
      row.PiecePrice = (((row.PieceAmount / row.PieceQuantity)* 100) / 100).toFixed(2)
      row.Ratio = (((row.PieceQuantity / rows.Quantity) * 100) / 100 ).toFixed(2) 
    },
    blurRatio(row){
      var index = null
      this.$refs.list.data.forEach((item,i) => {
        if(item.PieceSalaryId == row.PieceSalaryId){
          index = i
        }
      });
      row.PieceQuantity = (((this.$refs.list.data[index].Quantity  * row.Ratio)* 100) / 100).toFixed(2)
      row.PieceAmount = (((row.PiecePrice * row.PieceQuantity)* 100) / 100).toFixed(2)
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '汇总';
          return;
        }
        if(index === 2 || index === 4 || index === 5){
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] = (sums[index] * 100) / 100
            sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
          } else {
            sums[index] = '';
          }
        }
      })
      return sums;
    },
    handleNumberBlur(row,tableName){
      if(tableName == 'PiecePrice'){
        row.PieceAmount = (((row.PiecePrice * row.Quantity) * 100) /100).toFixed(2)
      }else if(tableName == 'PieceAmount'){
        row.PiecePrice = (((row.PieceAmount / row.Quantity) * 100) /100).toFixed(2)
      }
      row.ListData.forEach(item =>{
        item.PiecePrice = row.PiecePrice
        item.PieceAmount = (((item.PiecePrice * item.PieceQuantity) * 100) /100).toFixed(2)
        item.Ratio = (((item.PieceQuantity / row.Quantity) * 100) / 100).toFixed(2)
      })
    },
    del(rows, i, row, $index) {
      console.log("🚀 ~ del ~ $index:", $index)
      console.log("🚀 ~ del ~ row:", row)
      console.log("🚀 ~ del ~ i:", i)
      console.log("🚀 ~ del ~ rows:", rows)
      
      this.$refs.list.data[i].ListData.splice($index, 1);
    
      // this.prPieceSalaryDtsApi.delete({ ids:[row.PieceSalaryDtsId] }).then((res) => {
      //   if (res.Code == 0) {
      //     this.$message.success("删除成功");
      //     this.reload();
      //   } else {
      //     this.$message.error(res.Msg);
      //   }
      // });
    },
    onSaved(row){
      const Dts = row.ListData.map(item => {
        return {
          PieceSalaryDtsId: item.PieceSalaryDtsId ?? 0,
          EmpId: item.EmpId,
          PieceQuantity: item.PieceQuantity,
          PiecePrice: item.PiecePrice,
          PieceAmount: item.PieceAmount,
          DpId: item.DpId,
          TeamId: item.TeamId
        }
      })
      const o = {
        PieceSalaryId: row.PieceSalaryId ?? 0,
        Dts
      }
      this.prPieceSalaryDtsApi.batchSave(o).then((res) => {
        if (res.Code === 0) {
          this.$message.success('保存成功');
        } else {
          this.$message.error(res.Message);
        }
      })
    }
  },
};
</script>